module.exports = __webpack_public_path__ + "img/butterfly.dcebb6d3.png";